<template>
  <section class="piece-details">
    <header class="heaer-layout">
      <mo-pageheader>
        <template slot="title">Détail de la pièce: <span class="label" v-if="part && part.name != 'manualPartStock'">{{ part.name }}</span><span class="label" v-if="part && part.name == 'manualPartStock'">pièce manuelle</span></template>
        <template slot="action">
          <div class="buttons-container flex flex-end">
            <span class="btn-action primary" @click="handleGoBack" v-if="selectedPiece">Retour</span>
            <a class="btn-action primary" @click="$router.go(-1)" v-else>Retour</a>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <main class="main-layout">
      <!-- TAB SECTION -->
      <div class="flex flex-center">
<!--         <div
          class="tab"
          :class="activeTab == 'detail' ? 'active': ''"
          @click="activeTab = 'detail'"
          >Détails
        </div>
 --><!--         <div
          class="tab"
          :class="activeTab == 'documents' ? 'active': ''"
          @click="activeTab = 'documents'"
          >Fiches articles
        </div> -->
      </div>

      <!-- PIECE DETAILS SECTION -->
      <ba-card v-if="activeTab == 'detail'">
        <template slot="header">
          <span>Informations générales</span>
        </template>
        <template>
          <div class="cols">
            <div class="col-4">
              <ba-input type="text" label="Type de pièce" v-model="part_type" disabled></ba-input>
              <ba-input type="text" label="Marque" v-model="brand" disabled></ba-input>
              <ba-input type="text" label="Centre" v-model="company" disabled></ba-input>
              <div v-if="part && part.Company && isCompanyClosed(part.Company)" class="closure-warning">
                Centre fermé du {{ part.Company.closure_start | dateInput }} au {{ part.Company.closure_end | dateInput }}.
                Les commandes ne seront pas traitées pendant cette période.
              </div>
              <ba-input type="text" label="Immatriculation" v-model="matriculation" disabled></ba-input>
              <ba-input type="text" label="Carrosserie" v-model="carbody" disabled></ba-input>
            </div>
            <div class="col-4">
              <ba-input type="text" label="Type transmission" v-model="transmission_type" disabled></ba-input>
              <ba-input type="text" label="Modèle" v-model="model" disabled></ba-input>
              <ba-input type="text" label="Sku" v-model="sku" disabled></ba-input>
              <ba-input type="text" label="Emplacement / Casier" v-model="location" disabled></ba-input>
              <ba-input type="text" label="Cylindré" v-model="cylindre" disabled></ba-input>
            </div>
            <div class="col-4">
			  
              <div v-if="accessRestreintSku === 1" class="div-accessrestreint">
               <span class="btn-action primary btn-accessrestreint"  @click="clickBtnAccessReistreint()">Type {{part.part_type_id == 1 ? 'moteur' : 'boite'}}</span>
              </div>
              <ba-input type="text" label="Type moteur" v-model="motor" v-else-if="(accessRestreintSku === 0 && part.part_type_id == 1)" disabled></ba-input>
              <ba-input type="text" label="Type boîte" v-model="gearbox" v-else="(accessRestreintSku === 0 && part.part_type_id == 2)" disabled></ba-input>			  

              <ba-input type="text" label="Génération" v-model="generation" disabled></ba-input>
              <ba-input type="text" label="Prix d'achat" v-model="price" disabled></ba-input>
              <ba-input type="text" label="Id stock" v-model="stock_id" disabled></ba-input>
              <ba-input type="text" label="Nombre vitesse" v-model="gear_nb" disabled></ba-input>
            </div>
            <div class="col-4">
              <ba-input type="text" label="Code moteur" v-model="motor_code" v-if="part.part_type_id == 1" disabled></ba-input>
              <ba-input type="text" label="Code boîte" v-model="gearbox_code" v-if="part.part_type_id == 2" disabled></ba-input>
              <ba-input type="text" label="Version" v-model="version" disabled></ba-input>
              <ba-input type="text" label="Kilométrage" v-model="km" disabled></ba-input>
              <ba-input type="text" label="CIVS" v-model="policy" disabled></ba-input>
              <ba-input type="text" label="Date mise en circulation" v-model="circulation" disabled></ba-input>
            </div>
          </div>
          <ba-textarea label="Description de la pièce" :rows="8" v-model="description" disabled></ba-textarea>
          <div class="checkbox-container flex flex-center">
            <ba-checkbox v-model="appraised" disabled>Pièce expertisée</ba-checkbox>
            <ba-checkbox class="checkbox-margin" v-model="cleared" disabled>Pièce dépolluée</ba-checkbox>
            <ba-checkbox v-model="dismounted" disabled>Pièce démontée</ba-checkbox>
          </div>
          <span v-if="part.Image && part.Image.length > 0" class="bar"></span>
          <span v-else ><br/></span>
		  
          <div v-if="part.Image && part.Image.length > 0" class="carousel-container" :class="part.Image && part.Image.length < slideNumber ? 'carousel-center' : ''">
            <tiny-slider
              ref="tinyslider"
              v-if="part.Image && part.Image.length"
              :center="false"
              :loop="true"
              :lazyload="true"
              :items="slideNumber"
              :controls="isControllable"
              :controls-container="isControllable ? '.custom-pagination' : ''"
              :prev-button="isControllable ? '.prev' : ''"
              :next-button="isControllable ? '.next' : ''"
              :rewind="true"
              :nav="false"
            >
              <!-- FIXME : Dev purpose -->
              <div class="img-ctn tns-item" v-for="(image, index) in part.Image" :key="index">
                <img class="carousel-img carousel_loupe"
                :class="part.Image && part.Image.length >= slideNumber ? 'tns-lazy-img' : ''"
                :src="`${getImage(image.minify_path, part.Company.id, index)}`"
                :data-src="`${getImage(image.minify_path, part.Company.id, index)}`"
                @error="defaultImagePath" @click="ClickImgCarroussel(index)">
              </div>
            </tiny-slider>
            <div class="custom-pagination" id="carousel_0" v-if="isControllable">
              <button class="prev flex flex-center"><ab-icon icon="left"></ab-icon></button>
              <button class="next flex flex-center"><ab-icon icon="right"></ab-icon></button>
            </div>
          </div>
        </template>
      </ba-card>

      <!-- DOCUMENT REPORT MODAL -->
      <modal class="modal" name="modal-image" height="auto" width="780">
        <ba-card>
          <template slot="header">
            <span>{{ this.brand }} - {{ this.model }}</span>
          </template>      

          <template>
            <div class="carousel-container carousel-container2" :class="part.Image && part.Image.length < slideNumber ? 'carousel-center' : ''" >
              <tiny-slider style="width: 100% !important;height: 100% !important;"
                ref="tinyslider"
                v-if="part.Image && part.Image.length"
                :center="false"
                :loop="true"
                :lazyload="true"
                :items="slideNumber"
                :controls="isControllableModal"
                :controls-container="isControllableModal ? '.custom-paginationm' : ''"
                :prev-button="isControllableModal ? '.prevm' : ''"
                :next-button="isControllableModal ? '.nextm' : ''"
                :rewind="true"
                :nav="false"
              >

              <div class="img-ctnmodal tns-item">
                  <img class="carousel-img imgZoom"
                    :src="`${getImage(this.imgCarrousselPath, this.imgCarrousselCompanyId, this.imgCarrousselIndex)}`"
                    :data-src="`${getImage(this.imgCarrousselPath, this.imgCarrousselCompanyId, this.imgCarrousselIndex)}`"
                    @error="defaultImagePath">
              </div>

              </tiny-slider>
              <div class="custom-pagination custom-paginationm" v-if="isControllableModal">
                <button class="prevm flex flex-center" @click="prevCarrousselModal()"><ab-icon icon="left"></ab-icon></button>
                <button class="nextm flex flex-center" @click="nextCarrousselModal()"><ab-icon icon="right"></ab-icon></button>
              </div>
            </div>
          </template>

          <template slot="footer">
            <div class="buttons-container flex flex-end">
              <ba-button type="button" class="primary" @click.native="$modal.hide('modal-image')">Fermer</ba-button>
            </div>
          </template>
        </ba-card>
      </modal>    

      <!-- DOCUMENTS SECTION -->
      <!-- <ba-table v-if="activeTab == 'documents' && documents.length">
        <template slot="colgroup">
          <col>
          <col class="brand">
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
        </template>
        <template slot="body">
          <tr v-for="(document, index) in documents" :key="index">
            <td><img class="img-fit" :src="handleGetBrandImage(document.aaa_brand)" @error='defaultImage()' /></td>
            <td class="brand-data">{{ document.aaa_brand }} {{ document.aaa_model }}<span class="subelement">{{ document.aaa_energy }} - {{ document.tecdoc_date_min | dateYear }}</span></td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="motor in getTypeAdaptability(document.motor_adaptability)">
                  {{ motor }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="gearbox in getTypeAdaptability(document.gearbox_adaptability)">
                  {{ gearbox }}
                </li>
              </ul>
            </td>
            <td class="right">{{ document.aaa_steam_power }}</td>
            <td class="right">{{ document.aaa_fiscal_power }}</td>
            <td>{{ document.aaa_gearbox }}<span class="subelement">{{ document.aaa_gear_number }}</span></td>
            <td class="more">
              <ba-dropdown position="right">
                <template slot="button"><ab-icon icon="more"></ab-icon></template>
                <template slot="list">
                  <ul>
                    <li>
                      <router-link :to="{ name: 'DocumentDetails', params: { id: document.id }}" class="item">Plus de détails</router-link>
                    </li>
                  </ul>
                </template>
              </ba-dropdown>
            </td>
          </tr>
        </template>
        <template slot="head">
          <tr>
            <th :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols" :key="index" @click="sortby(index)">
              <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
            </th>
          </tr>
        </template>
      </ba-table>
      <div v-if="!documents.length">
        <p class="no-data">Pas de fiches articles disponibles</p>
      </div> -->
    </main>

    <footer class="footer-layout">
      <div class="buttons-container flex flex-end">
        <span class="btn-action primary" @click="handleGoBack" v-if="selectedPiece">Retour</span>
        <a class="btn-action primary" @click="$router.go(-1)" v-else>Retour</a>
      </div>
    </footer>

  </section>
</template>

<script>
import { AbIcon, BaButton, BaCard, BaCheckbox, BaDropdown, BaInput, BaSelect, BaTable, BaTextarea } from '@ab/basic-components';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';
import VueTinySlider from 'vue-tiny-slider';
import { mapState } from 'vuex';

export default {
  name: 'PieceDetails',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaCheckbox,
    BaDropdown,
    BaInput,
    BaSelect,
    BaTable,
    BaTextarea,
    MoPageheader,
    'tiny-slider': VueTinySlider
  },
  props: {
    skuProp: String,
  },
  mixins: [ sortableMixin ],
  async mounted() {

    this.$store.commit('setSpinner', true);
    if ((this.$route.params && this.$route.params.sku) || this.selectedPiece) {
      this.sku = this.$route.params.sku || this.selectedPiece;
      await this.$store.dispatch('getPartInfo', this.sku);
      this.accessRestreintSku  = await this.$store.dispatch('getAccessRetreint', { typeRch: 'sku', brand: this.brand, model: this.model, sku: this.sku, part_type: this.part_type, motor: this.motor, gearbox: this.gearbox });	
    }
    const data = await this.$store.dispatch('getPartDocuments', this.sku);
    this.$store.commit('setSpinner', false);
    // console.log(this.$refs.tinyslider);
    // console.log(this.$refs.tinyslider.slider.getInfo());
    // this.$refs.tinyslider.slider.destroy();
    // this.$refs.tinyslider.slider.rebuild();

    let idStock = this.part.id

    let listViewStockItem = JSON.parse(sessionStorage.getItem('listViewStockItem'))
    if(listViewStockItem !== null){
      let flag = 0;
      listViewStockItem.forEach(function(Item){
        if(idStock == Item) {
          flag = 1
        }
      })
      if(flag == 0) {
        listViewStockItem.push(idStock)
        sessionStorage.setItem('listViewStockItem', JSON.stringify(listViewStockItem))
      } 
    } else {
      let listViewStockItem = [idStock]
      sessionStorage.setItem('listViewStockItem', JSON.stringify(listViewStockItem))
    }

  },
  data() {
    return {
      imgCarrousselPath : '',
      imgCarrousselCompanyId : '',
      imgCarrousselIndex : '',
      selectedPiece: this.skuProp,
      appraised: '',
      brand: '',
      carbody: '',
      circulation: '',
      cleared: '',
      company: '',
      cylindre: '',
      description: '',
      dismounted: '',
      gear_nb: '',
      gearbox: '',
      gearbox_code: '',
      generation: '',
      km: '',
      location: '',
      matriculation: '',
      model: '',
      motor: '',
      motor_code: '',
      part_type: '',
      policy: '',
      price: '',
      sku: '',
      stock_id: '',
      transmission_type: '',
      version: '',
      activeTab: 'detail',
      slideNumber: 3,
      path: `${process.env.VUE_APP_ROOT_API}/upload/part/default.png`,
      accessRestreintSku: '',
      cols: [
        { label: '', sortable: false, sorted: '', key: '', class: '' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: '' },
        { label: 'Type moteur', sortable: true, sorted: '', key: 'motor_adaptability', class: '' },
        { label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_adaptability', class: '' },
        { label: 'Puissance Ch.', sortable: true, sorted: '', key: 'aaa_steam_power', class: 'right' },
        { label: 'Puissance Fis.', sortable: true, sorted: '', key: 'aaa_fiscal_power', class: 'right' },
        { label: 'Boîte de vitesses', sortable: true, sorted: '', key: 'aaa_gearbox', class: '' },
        { label: '', sortable: false, sorted: '', key: '', class: '' },
      ],
    }
  },
  computed: {
    ...mapState({ documents: state => state.parts.documents }),
    ...mapState({ part: state => state.parts.part }),
    computedCenter() {
      if (this.part && this.part.Image && this.part.Image.length >= this.slideNumber) {
        return true;
      }
      return false;
    },
    startIndex() {
      if (this.part && this.part.Image && this.part.Image.length >= this.slideNumber) {
        return 1;
      }
      return 0;
    },
    isControllable() {
      if (this.part.Image && this.part.Image.length > this.slideNumber) { return true; }
      return false;
    },
    isControllableModal(){
      if (this.part.Image && this.part.Image.length > 1) { return true; }
      return false;
    }  
  },
  methods: {
    isCompanyClosed(company) {
      if (!company || !company.closure_start || !company.closure_end) return false;
      const today = new Date().toISOString().slice(0, 10);
      const start = String(company.closure_start).slice(0, 10);
      const end = String(company.closure_end).slice(0, 10);
      return today >= start && today <= end;
    },
    clickBtnAccessReistreint() {
      this.accessRestreintSku = 0
      this.$store.dispatch('setHistoAccess', { typeRch: 'sku', brand: this.brand, model: this.model, sku: this.sku, part_type: this.part_type, motor: this.motor, gearbox: this.gearbox });	
	},
    ClickImgCarroussel(imgIndex) {
      this.imgCarrousselIndex = imgIndex
      for (var i = 0; i < this.part.Image.length; i++) {
        if(i == imgIndex){
          this.imgCarrousselPath = this.part.Image[imgIndex].path
          this.imgCarrousselCompanyId = this.part.Company.id           
        }
      }
      this.$modal.show('modal-image');
    },    
    prevCarrousselModal(){
      if(this.imgCarrousselIndex > 0) {
        this.imgCarrousselIndex--;
        for (var i = 0; i < this.part.Image.length; i++) {
          if(i == this.imgCarrousselIndex){
            this.imgCarrousselPath = this.part.Image[i].path
            this.imgCarrousselCompanyId = this.part.Company.id            
          }
        }
      }else{
        this.imgCarrousselIndex = this.part.Image.length  - 1;
        this.imgCarrousselPath = this.part.Image[this.imgCarrousselIndex].path
        this.imgCarrousselCompanyId = this.part.Company.id          
      }
    },
    nextCarrousselModal(){
      if(this.imgCarrousselIndex + 1 < this.part.Image.length) {
        this.imgCarrousselIndex++;
        for (var i = 0; i < this.part.Image.length; i++) {
          if(i == this.imgCarrousselIndex){
            this.imgCarrousselPath = this.part.Image[i].path
            this.imgCarrousselCompanyId = this.part.Company.id            
          }
        }
      }else{
        this.imgCarrousselIndex = 0;
        this.imgCarrousselPath = this.part.Image[this.imgCarrousselIndex].path
        this.imgCarrousselCompanyId = this.part.Company.id          
      }
    },    
    /* -- Modal handling --*/
    handleGoBack() {
        console.log("handleGoBack")
      this.$emit('close');
    },
    // Get image
    getImage(path, companyId, index) {
        if(path.slice(0, 4) == "http") {
            return path;
        }
        else {
            let baseApi = process.env.VUE_APP_ROOT_API;
            return baseApi+path;
            return `${baseApi}/upload/part/${companyId}/${this.sku}/f${index + 1}.png`;
        }
    },
    defaultImagePath(e) {
	  // pour les images 'path' on se contente
	  // de remplacer par une image vide si existe pas	
	  e.target.src = this.path;
    },	
    defaultImage(url, index, mode) {
      // pour les images 'minify_path' on se contente
      // on ne prend pas sur le front les images qui n'existent
      // pas pour ne pas casser le carroussel	
      // on vire l'image du store et la vue se recalcule
      // this.$store.dispatch('deleteImgStore', { value: url, index: index });
	  
      document.getElementById('tns1').style.setProperty('width', 'calc(100%)');
    },
    /* Get document motors & gearboxes */
    getTypeAdaptability(adap) {
      const adapArray = (adap && adap.length) ? adap.split(',') : [];
      return adapArray;
    },
    /* Get brand image */
    handleGetBrandImage(brand) {
      let text = brand.split(/[ -]+/)[0].toLowerCase();
      if (text == 'citroën') { text = 'citroen'; }
      if (text == 'vw') { text = 'volkswagen'; }
      if (text == 'land') { text = 'rover'; }
      if (text == 'bedford') { text = 'vauxhall'; }
      return `https://cdn.activcar.fr/media/64/brands/${text}.png`;
    },
  },
  watch: {
    part(newPart, oldPart) {
      this.appraised = newPart.appraised;
      this.brand = newPart.Brand.name ? newPart.Brand.name : '';
      this.carbody = newPart.carbody;
      this.circulation = newPart.circulation_year ? this.$options.filters.dateInput(newPart.circulation_year) : '';
      this.cleared = newPart.cleared;
      this.company = newPart.Company.name;
      this.cylindre = newPart.cylindre;
      this.description = newPart.description;
      this.dismounted = newPart.dismounted;
      this.gear_nb = newPart.nb_gears;
      this.gearbox = newPart.gearbox;
      this.gearbox_code = newPart.gearbox_code;
      this.generation = newPart.Generation.name ? newPart.Generation.name : '';
      this.km = this.$options.filters.number(newPart.km);
      this.location = newPart.location;
      this.matriculation = newPart.matriculation;
      this.model = newPart.Model.name ? newPart.Model.name : '';
      this.motor = newPart.motor;
      this.motor_code = newPart.motor_code;
      this.part_type = newPart.Part_type.name;
      this.policy = this.$options.filters.number(newPart.policy);
      this.price = this.$options.filters.currency(newPart.price);
      this.stock_id = this.$options.filters.number(newPart.stock_id);
      this.transmission_type = newPart.transmission_type;
      this.version = newPart.Version.name || '';
    },
  }
};
</script>

<style scoped>
/* Margin between containers */
.ba-card, .ba-table { margin-top: 2rem; }  /* header & card */
.checkbox-container {
  margin-top: 1.5rem;   /* textarea & checkboxes */
  margin-bottom: 2rem;  /* checkboxes & bar */
}

.piece-details .ba-textarea { margin: 0 1rem; }

.checkbox-margin { margin: 0 5rem; }

/* Tab style */
.imgZoom {
  position: relative;
}
#carousel_0 {
  display: block !important;
}
/* Bars */
.bar {
  position: relative;
  display: block;
}
.bar:before, .bar:after {
  position: absolute;
  background: rgb(196, 196, 196);
  content: '';
  height: 1px;
  width: 45%;
  bottom: 0px;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}
.img-ctn {
  height: 260px;
  padding-right: 20px;
}
.img-ctnmodal {
  height: 400px;
  width: auto;
}
.img-ctn:last-of-type {
  padding-right: 0px;
}
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.carousel_loupe {
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.closure-warning {
  color: #c0392b;
  font-weight: 600;
  font-size: 0.85rem;
  margin: -0.5rem 1rem 1rem 1rem;
}
</style>
<style>
/* Carousel */
/*  Center Carousel */
.carousel-container {
  width: 75%;
  margin: 5rem auto 0;
  padding-bottom: 1rem;
  text-align: center;
}
.carousel-container2 {
  width: 78% !important; 
  margin-top: 22px;
}
.carousel-center .tns-inner {
  display: flex;
  justify-content: space-around;
  transform: none;
}

/*  Image / slide */
#app .carousel-container img {
/*  display: inline-block;
  object-fit: contain;
  width: 40%;*/
}

/*  Navigation buttons */
.piece-details .carousel-container { position: relative; }
.piece-details .custom-pagination .prevm,
.piece-details .custom-pagination .nextm,
.piece-details .custom-pagination .prev,
.piece-details .custom-pagination .next {
  position: absolute;
  top: 50%;
  margin-top: -32px;
  width: 64px;
  height: 64px;
  color: var(--app-white-color);
  background-color: var(--app-primary-color);
  border: none;
  border-radius: 50%;
  box-shadow: 1px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.piece-details .custom-pagination .ab-icon {
  width: 40px;
  height: 40px;
}
.piece-details .custom-pagination .prevm { left: -64px; }
.piece-details .custom-pagination .nextm { right: -64px; }
.piece-details .custom-pagination .prev { left: -64px; }
.piece-details .custom-pagination .next { right: -64px; }
.piece-details .custom-pagination div:focus {
  outline: none;
}
.custom-paginationm {
  display: block!important;
}
.div-accessrestreint {
  padding-top: 2px;
  padding-bottom: 22px;
}
</style>
<style src="@/assets/styles/tabs.css"></style>
